export function ImporterIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15332_15751)">
        <path
          d="M27 9.2439C31.7739 9.2439 36.3523 11.1403 39.7279 14.516C43.1036 17.8916 45 22.47 45 27.2439C45 32.0178 43.1036 36.5962 39.7279 39.9718C36.3523 43.3475 31.7739 45.2439 27 45.2439C22.2261 45.2439 17.6477 43.3475 14.2721 39.9718C10.8964 36.5962 9 32.0178 9 27.2439C9 25.1735 9.35718 23.1187 10.0558 21.1697"
          stroke="#2D2D2D"
          strokeWidth="1.5"
        />
        <path d="M38.1456 13.1106C35.1512 15.9933 31.1564 17.6037 27 17.6036" stroke="#2D2D2D" strokeWidth="1.5" />
        <path
          d="M15.9108 41.3231C18.8996 38.4736 22.8706 36.884 27 36.884C31.1294 36.884 35.1004 38.4736 38.0892 41.3231"
          stroke="#2D2D2D"
          strokeWidth="1.5"
        />
        <path d="M27 9.23486V45.2541" stroke="#2D2D2D" strokeWidth="1.5" />
        <path d="M8.99088 27.2446H45.0101" stroke="#2D2D2D" strokeWidth="1.5" />
        <path
          d="M27 9.2439C29.3869 9.2439 31.6761 11.1403 33.364 14.516C35.0518 17.8916 36 22.47 36 27.2439C36 32.0178 35.0518 36.5962 33.364 39.9718C31.6761 43.3475 29.3869 45.2439 27 45.2439C24.6131 45.2439 22.3239 43.3475 20.636 39.9718C18.9482 36.5962 18 32.0178 18 27.2439C18 25.8301 18.0833 24.4213 18.2481 23.0465"
          stroke="#2D2D2D"
          strokeWidth="1.5"
        />
        <path
          d="M31.5216 22.6425C31.2001 20.5528 30.1509 18.5822 28.5967 17.1487C27.432 16.0745 25.9805 15.2976 24.4231 15.0057C23.2318 14.7824 21.9878 14.8445 20.8248 15.1853C22.1192 15.905 23.263 16.8943 24.1615 18.0715C24.7483 18.8404 25.2309 19.688 25.6019 20.5812C26.016 21.5781 26.2914 22.6324 26.4177 23.7043L23.1889 24.3762L30.2956 29.5453L34.7505 21.9705L31.5216 22.6425Z"
          fill="#2D2D2D"
        />
        <path
          d="M16.2713 23.9352L27 19.1585V7.56909L16.2713 12.3458V23.9352Z"
          stroke="#2D2D2D"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M16.2713 23.9352L5.54257 19.1585V7.56909L16.2713 12.3458V23.9352Z"
          stroke="#2D2D2D"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M5.54233 7.56944L16.271 2.79272L26.9998 7.56944"
          stroke="#2D2D2D"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M20.1396 4.51489L9.41089 9.29161V12.4075L12.2206 13.6584V10.5425L22.9493 5.7658"
          stroke="#2D2D2D"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15332_15751">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
